export default __webpack_public_path__ + "static/media/icon11.36617e58.svg";